import { apiDelete, apiGet, apiPost } from './client';
import type { IpWhitelistRow } from './types';

export const userIpWhitelistApi = {
  list: (userId: number) => apiGet<{ rows: IpWhitelistRow[] }>(`/api/users/${userId}/ip-whitelist`),
  add: (userId: number, input: { cidr: string; label: string; expiresAt?: string }) =>
    apiPost<IpWhitelistRow>(`/api/users/${userId}/ip-whitelist`, input),
  remove: (userId: number, rowId: number) =>
    apiDelete<{ ok: true }>(`/api/users/${userId}/ip-whitelist/${rowId}`),
};
